
 
<mat-form-field *ngIf='field '  appearance="outline" [style.width]="field.matFormFieldWidth" [formGroup]="group">
    


<input type="text"
                 [placeholder]="field.placeHolder"
                 aria-label="Number"
                 matInput
                 [formControlName]="field.name"     
                 [formControl]="myControl"            
                 [matAutocomplete]="auto"
                 (input)="filter($event.target.value)"
                 [(ngModel)]='inputValue'
                 (keyup)='keyup(field.name, $event.currentTarget.value, field.select.options)'
                 >
                 <mat-icon class='menuArrowDown' matSuffix>keyboard_arrow_down</mat-icon>

    <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions" [value]="option.name" (click)="selected(field.name, option)">
            <mat-icon color="primary" [svgIcon]="option.icon"></mat-icon>   {{option.name}}
        </mat-option>
    </mat-autocomplete>
    
    

  <!--



    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>

    <span matSuffix *ngIf="field?.suffix">    
        <ng-container *ngIf="field.suffix.icon; else isNotIcon">
            <mat-icon>{{field.suffix.text}}</mat-icon>
        </ng-container>
        <ng-template #isNotIcon>
            {{field.suffix.text}}
        </ng-template>
    </span>

    <span matPreffix *ngIf="field?.preffix">    
            <ng-container *ngIf="field.preffix.icon; else isNotIcon">
                <mat-icon>{{field.preffix.text}}</mat-icon>
            </ng-container>
            <ng-template #isNotIcon>
                {{field.preffix.text}}
            </ng-template>
        </span>
    -->
</mat-form-field>

